/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  constructor(private readonly httpClient: HttpClient) {
    // Dependency injection
  }

  fetchConfigToken(b2cToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${b2cToken}`
    });
    return this.httpClient
      .post<any>(`${environment.API_URI}/digitalwallets/v1/profile/wallet-checkout/token/config`, {}, { headers })
      .pipe(map(response => response.access_token));
  }
}
